import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { IPaperWork } from "../../../models/IPaperwork";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { IDocumentMastDropdown } from "../../../models/IDropdown";
import { ILogin } from "../../../models/Login";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { useNavigate } from "react-router-dom";
import { POStatus } from "../../../models/PurchaseOrder";

interface IFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    status?: string | null,
    consultant_Name?: string | null,
    pO_Status?: POStatus | null,
}

const EmptyTSFilter: IFilter = {
    fromDate: null,
    toDate: null,
    status: "",
    consultant_Name: "",
    pO_Status: POStatus.Joined
}

const schema = yup.object({
    document_Type: yup.string().required("Select Document Type"),
    document_Name: yup.string().required("Select Document Name").min(1, "Select Document Name"),
    // expiration_Date: yup.date().required("Expiration Date is required").typeError("Expiration Date is required"),
});

export const ShowDocuments = () => {
    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>();
    const [documentsList, setDocumentsList] = useState<{
        consultant_documents: Array<IPaperWork>,
        vendor_documents: Array<IPaperWork>,
    }>({ consultant_documents: [], vendor_documents: [] });
    const [docFile, setDocFile] = useState<File | null | any>(null);
    const [consultant, setConsultant] = useState<Array<any>>();
    const [filters, setFilters] = useState<IFilter>(EmptyTSFilter);
    // const [po, setPo] = useState<any>();

    const toast = useRef<any>(null);
    const navigate = useNavigate();

    const [paperWork, setPaperWork] = useState<IPaperWork>({ document_Type: "Vendor" });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

    const { control, handleSubmit, unregister, formState: { errors }, reset, setValue, watch } = useForm<IPaperWork>({
        resolver: yupResolver(schema),
        defaultValues: { document_Type: "Vendor" },
        shouldFocusError: false
    });
    const selectedDocument = watch("document_Name");

    const loadDocuments = async (type?: string) => {
        const response = await Fetch("Dropdown/documentForResource", "GET", null, `userType=4`, null);
        if (response) {
            const data: Array<IDocumentMastDropdown> = await response.json();
            const consultant: Array<IDocumentMastDropdown> = [];
            const Vendor: Array<IDocumentMastDropdown> = [];
            const Client: Array<IDocumentMastDropdown> = [];
            data.forEach((d: IDocumentMastDropdown) => {
                if (!(d.document_Name.includes("Vendor") || d.document_Name.includes("Client"))) consultant.push(d);
                if ((d.document_Name.includes("Vendor"))) Vendor.push(d);
                if ((d.document_Name.includes("Client"))) Client.push(d);
            });
            if (type === "Consultant") {
                setDocuments(consultant);
            }
            else if (type === "Vendor") {
                setDocuments(Vendor);
            } else if (type === "Client") {
                setDocuments(Client);
            } else {
                setDocuments(Vendor);
            }

        }
    }

    const loadDocumentsList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetailsExternalUser/apw", "GET", null, `sub_Vendor_ID=${loginObj.sub_Vendor_ID || 0}`, toast);
        if (response) {
            const data: {
                consultant_documents: Array<IPaperWork>,
                vendor_documents: Array<IPaperWork>,
            } = await response.json();
            setDocumentsList(data);
        }
        setLoading(false);
    }

    const getConsultantName = async () => {
        const response = await Fetch("DropDown/consultantNameList", "GET", null, null, null);
        if (response) {
            const data: any = await response.json();
            setConsultant(data);
        }
    }

    useEffect(() => { loadDocuments(); getConsultantName(); loadDocumentsList() }, []);
    // useEffect(() => { loadPODetails(); }, [filters]);
    // useEffect(() => { if (po?.pO_ID) loadDocumentsList(); }, [po]);

    useEffect(() => {
        let expiration_Date;
        if (paperWork.expiration_Date) expiration_Date = new Date(paperWork.expiration_Date);
        reset({ ...paperWork, expiration_Date });
    }, [paperWork]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "document_Type") {
                if (value.document_Type === "Vendor" && value.document_Type != null) {
                    loadDocuments("Vendor");

                }
                // else if (value.document_Type === "Client" && value.document_Type != null) {
                //     loadDocuments("Client");

                // } else if (value.document_Type === "Consultant" && value.document_Type != null) {
                //     loadDocuments("Consultant");
                // } else {
                //     loadDocuments("Consultant");
                // }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const saveDocument = async (body: IPaperWork, isDelete?: boolean) => {
        if (docFile === null) {
            toast.current.show({ severity: 'error', detail: "File is required", life: 3000 });
            return;
        }

        setLoading(true);
        // body.pO_ID = po.pO_ID;
        // body.consultant_ID = po.consultant_ID;
        body.sub_Vendor_ID = loginObj.sub_Vendor_ID || 0;
        // body.prime_Vendor_ID = po.prime_Vendor;
        const method = body.document_ID ? "PUT" : "POST";
        const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

        const formData = new FormData();
        formData.append("file", docFile);
        formData.append("paperWork", JSON.stringify(body));
        //formData.append('userType', `${loginObj.user_Type}`);
        //formData.append('userID', `${loginObj.user_Type === 2 ? loginObj.consultant_ID : loginObj.sub_Vendor_ID}`);
        const params = {
            method: method,
            headers: { Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`, },
            body: formData,
        };
        const response = await fetch(`${baseUrl}vwPODetailsExternalUser/apw?subvendorUser=${loginObj.sub_Vendor_ID || 0}&userType=${loginObj.user_Type}`, params);

        // const response = await Fetch("vwPODetails/apw", method, body, null, toast);
        if (response.ok) {
            toast.current.show({ severity: 'success', content: `Document ${message}` });
            setPaperWork({ document_Type: "Consultant" });
            loadDocumentsList();
            setDocFile(null);
            reset({ document_Type: "Consultant" });
            loadDocuments();
        } else {
            const errorText = await response.text();
            console.error('Error:', errorText);
            toast.current.show({ severity: 'error', detail: errorText, life: 3000 });
            setLoading(false);
        } setLoading(false);

        // if (isDelete) {
        //     const response = await Fetch("vwPODetails/apw", "DELETE", body, null, toast);
        //     if (response) {
        //         toast.current.show({ severity: 'success', content: `Document Deleted Successfully` });
        //         setPaperWork({ document_Type: "Consultant" });
        //         loadDocumentsList();
        //     } else setLoading(false);
        // } else {
        //     const method = body.document_ID ? "PUT" : "POST";
        //     const message = body.document_ID ? "Updated Successfully" : "Added Successfully";

        //     const response = await Fetch("vwPODetails/apw", method, body, null, toast);
        //     if (response) {
        //         toast.current.show({ severity: 'success', content: `Document ${message}` });
        //         setPaperWork({ document_Type: "Consultant" });
        //         loadDocumentsList();
        //     } else setLoading(false);
        // }
    }

    function onSubmit(data: any) {
        if ((typeof selectedDocument === "string" &&
            selectedDocument !== "Vendor VOID CHECK"
            && selectedDocument !== "Vendor ACH"
        )) {
            if (data.expiration_Date == "" || data.expiration_Date == null) {
                toast.current.show({ severity: 'error', content: "please select expiration date" });

            } else {
                saveDocument(data);
            }
        } else {
            saveDocument(data);
        }

    }

    const fileUploade = async (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 102400 * 5) {
            toast.current.show({ severity: 'error', content: "Document should be less than 5 MB." });
            event.options.clear();
        } else {
            setDocFile(event.files[0]);
            toast.current.show({ severity: 'success', content: "Document Selected." });
            event.options.clear();
        }
    }

    // const uploadeFile = async (file: File) => {
    //     setLoading(true);
    //     let formData = new FormData();
    //     formData.append("file", file);

    //     const params = {
    //         method: "POST",
    //         headers: {
    //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
    //         },
    //         body: formData
    //     };
    //     const response = await fetch(`${baseUrl}Ticket/file`, params);
    //     if (response) {
    //         const data = await response.text();
    //         setValue("document_Path", data);
    //         toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
    //     }
    //     setLoading(false);

    //     return response ? true : false;
    // }

    const downloadDocument = async (data: IPaperWork) => {
        // data.pO_ID = po.pO_ID;
        // data.consultant_ID = po.consultant_ID;
        //data.sub_Vendor_ID = loginObj.sub_Vendor_ID || 0;
        // data.prime_Vendor_ID = po.prime_Vendor;
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetailsExternalUser/document"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.document_Path ? data.document_Path : "document";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    function onHide() {
        // hideDialog();
        setDocumentsList({ consultant_documents: [], vendor_documents: [] });
        setPaperWork({ document_Type: "Consultant" });
    }

    const expiration_Date = (rowData: IPaperWork) => {
        let date;
        if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const viewDocument = async (data: IPaperWork) => {
        // data.pO_ID = po.pO_ID;
        // data.consultant_ID = po.consultant_ID;
        data.sub_Vendor_ID = loginObj.sub_Vendor_ID || 0;
        // data.prime_Vendor_ID = po.prime_Vendor;
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetailsExternalUser/viewDocument"}?subvendorID=${data.sub_Vendor_ID}&path=${data.document_Path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                window.open(href, '_blank');
                setTimeout(() => {
                    window.URL.revokeObjectURL(href);
                }, 100);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const file = (rowData: IPaperWork) => {
        return (<>
            {/* <span onClick={() => viewDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline mr-2">View</span> */}
            <span onClick={() => downloadDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">Download</span>
        </>);
    };
    const actionBodyTemplate = (rowData: IPaperWork) => {
        return <div style={{ display: 'flex' }}>
            <Button icon="pi pi-pencil" label="Update" className="p-button-rounded  p-button-text" onClick={() => {
                loadDocuments(rowData.document_Type);
                setPaperWork({ ...rowData });
            }} />
            {/* <Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => saveDocument({ ...rowData }, true)} /> */}
        </div>
    };

    // const loadPODetails = async (filter?: any) => {
    //     const response = await Fetch("vwPODetailsExternalUser/getLatestPO", "GET", null, `filter=${JSON.stringify(filter || filters)}`, null);
    //     if (response) {
    //         const data = await response.json();
    //         console.log(data);
    //         setPo(data[0]);
    //     }
    // };

    const goToDashboard = () => {
        navigate("/dashboard");
    };

    const rightToolbarTemplate = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <p className="w-full flex justify-content-between pr-2"><span></span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
                </span> */}
        </div>
    );

    const leftToolbarTemplate = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <p className="w-full flex justify-content-between pr-2"><span style={{ fontWeight: "bold" }}>My Documents</span><span></span></p>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
                </span> */}
        </div>
    );

    useEffect(() => {
        if (
            selectedDocument === "Vendor VOID CHECK" || selectedDocument === "Vendor ACH"
            // (selectedDocument !== "SSN" && selectedDocument !== "W2" && selectedDocument !== "W4")
        ) {
            unregister("expiration_Date");
        }
    }, [selectedDocument, unregister]);

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} left={leftToolbarTemplate}></Toolbar>
            <Card className="mt-3">
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                    {/* <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Type" control={control} name="document_Type" error={errors.document_Type?.message} options={PODocType} optionLabel="name" optionValue="name" placeholder="Select Document Type" /> */}
                    <JVDropdown required column={2} disabled={paperWork.document_ID !== undefined && paperWork.document_ID !== 0} label="Document Name" control={control} name="document_Name" error={errors.document_Name?.message} options={documents} optionLabel="document_Name" optionValue="document_Name" placeholder="Select Document Name" />
                    {(
                        (typeof selectedDocument === "string" &&
                            selectedDocument !== "Vendor VOID CHECK"
                            && selectedDocument !== "Vendor ACH")
                    ) && <JVDate column={2} label="Expiration Date" required control={control} name="expiration_Date" error={errors.expiration_Date?.message} />}
                    <div className="field col-12 md:col-3">
                        <label htmlFor="file">Document<span style={{ color: 'red' }}>*</span></label>
                        <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" customUpload auto uploadHandler={fileUploade} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="">&nbsp;</label>
                        <Button loading={loading} label="SUBMIT" type="submit"></Button>
                    </div>
                </form>
                {/* <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                    size="small" value={documentsList.consultant_documents} header="Consultant Document List" showGridlines stripedRows loading={loading}
                >
                    <Column field="document_Name" header="Document Name" />
                    <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                    <Column field="file" header="File" body={file} />
                    <Column field="addedByName" header="Added By" />
                    <Column field="editedByName" header="Edited By" />
                    <Column field="document_Status" header="Status" />
                    <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
                </DataTable> */}
                <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                    size="small" value={documentsList.vendor_documents} header="Vendor Document List" showGridlines stripedRows loading={loading}
                >
                    <Column field="document_Name" header="Document Name" />
                    <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                    <Column field="file" header="File" body={file} />
                    <Column field="addedByName" header="Added By" />
                    <Column field="editedByName" header="Edited By" />
                    {/* <Column field="document_Status" header="Status" /> */}
                    <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
                </DataTable>
            </Card>
            <Toast ref={toast} />
        </>
    );
}